import http from "../http"

class SurveyService {

    async listTemplates(data) {
        const rqst = await http.post('/survey/template/list/', data)
        return rqst.data
    }

    async getTemplateDetail(data) {
        const rqst = await http.post('/survey/template/detail/', data)
        return rqst.data
    }

    async createTemplate(data) {
        const rqst = await http.post('/survey/template/create/', data)
        return rqst.data
    }

    async updateTemplate(data) {
        const rqst = await http.post('/survey/template/update/', data)
        return rqst.data
    }

    async createTemplateQuestion(data) {
        const rqst = await http.post('/survey/template/question/create/', data)
        return rqst.data
    }

    async updateTemplateQuestion(data) {
        const rqst = await http.post('/survey/template/question/update/', data)
        return rqst.data
    }

    async listSurveys(page, data) {
        const rqst = await http.post('/survey/list/?page=' + (page || 1), data)
        return rqst.data
    }

    async getSurveyDetail(data) {
        const rqst = await http.post('/survey/detail/', data)
        return rqst.data
    }

    async createSurvey(data) {
        const rqst = await http.post('/survey/create/', data)
        return rqst.data
    }

    async previewActivateSchedule(data) {
        const rqst = await http.post('/survey/activate/schedule_preview/', data)
        return rqst.data
    }

    async activateSurvey(data) {
        const rqst = await http.post('/survey/activate/', data)
        return rqst.data
    }

    async closeSurvey(data) {
        const rqst = await http.post('/survey/close/', data)
        return rqst.data
    }

    async getPendingSurveys(data) {
        const rqst = await http.post('/survey/pending/', data)
        return rqst.data
    }

    async submitResponse(data) {
        const rqst = await http.post('/survey/submit/', data)
        return rqst.data
    }

    async getDashboardStats(data) {
        const rqst = await http.post('/survey/dashboard/', data)
        return rqst.data
    }

    async toggleAutoDispatch(data) {
        const rqst = await http.post('/survey/trigger/toggle/', data)
        return rqst.data
    }

    async listTriggers(data) {
        const rqst = await http.post('/survey/trigger/list/', data)
        return rqst.data
    }

    async createTrigger(data) {
        const rqst = await http.post('/survey/trigger/create/', data)
        return rqst.data
    }

    async updateTrigger(data) {
        const rqst = await http.post('/survey/trigger/update/', data)
        return rqst.data
    }

    async deleteTrigger(data) {
        const rqst = await http.post('/survey/trigger/delete/', data)
        return rqst.data
    }

    async listTriggerDispatches(data) {
        const rqst = await http.post('/survey/trigger/monitor/', data)
        return rqst.data
    }

    async getModuleOverview(data) {
        const rqst = await http.post('/survey/overview/', data)
        return rqst.data
    }
}

const surveyService = new SurveyService()

export default surveyService
